<template>
    <div class="order-details">
        <div class="order-header card p-2 pt-3 pb-1 mb-3">
            <div class="d-flex align-items-center justify-content-between flex-wrap">
                <div class="d-flex align-items-center mb-2">
                    <div class="order-badge mr-2">#{{ detailedItem.id }}</div>
                    <div class="text-muted small" v-if="detailedItem.text_mark">{{ detailedItem.text_mark }}</div>
                </div>
                <div class="text-secondary small mb-2">
                    <i class="fas fa-user-circle text-orange mr-1"></i>
                    Sales менеджер: <span class="font-weight-bold">{{ getSalesManagerName() }}</span>
                </div>
                <div class="d-flex align-items-center mb-2">
                    <span class="status-chip mr-2">
                        <i class="fas fa-info-circle mr-1"></i>{{ getStatusName() }}
                    </span>
                    <b-dropdown
                        id="fasteChangeOrderStatus"
                        variant="link"
                        toggle-class="text-decoration-none p-0 mb-1"
                        no-caret
                        class="p-0"
                        v-if="isAdmin"
                        :disabled="whyICanBeDisabled()"
                    >
                        <template #button-content>
                            <b-icon
                                v-if="!detailedItem.loading"
                                variant="secondary"
                                icon="caret-down-fill"
                                class="cursor-pointer"
                            ></b-icon>
                            <i class="fas fa-spinner fa-spin ml-1 text-secondary" v-if="detailedItem.loading"></i>
                        </template>
                        <tsoft-select-of-properties
                            :reference_id="35"
                            :dropDownSelect="true"
                            :needNullElement="false"
                            :defaultSelectName="`Выберите статус`"
                            :selected="detailedItem.reference_status_id"
                            @set="fastChangeStatusOfOrder"
                            :excludeArray="[359,360,361,421,424]"
                        ></tsoft-select-of-properties>
                    </b-dropdown>
                    <button
                        v-if="isAdmin && detailedItem.reference_status_id === 421"
                        type="button"
                        class="btn btn-sm btn-outline-green ml-2"
                        @click="changeOrderStatus(detailedItem.id, 361)"
                    >Вернуть завершен</button>
                </div>
            </div>
        </div>
        <div class="row mt-3">
            <div class="col-md-12">
                <table class="table table-hover table-borderless table-fixed table-sm details-table" style="display: none;">
                <tbody>
                    <tr v-if="false"></tr>
                    <tr v-if="false"></tr>
                    <tr v-if="false"></tr>
                    <tr v-if="false"></tr>
                    <tr v-if="false"></tr>
                    <tr v-if="false"></tr>
                    
                    <tr v-if="false"></tr>
                    <tr v-if="!isAgent">
                      <td class="table-title-details align-top">Отметки</td>
                      <td>
                        <div class="align-items-center d-flex justify-content-between flex-wrap">
                          <template v-if="detailedItem.order_substatuses.length > 0">
                            <div
                              v-for="(substatus, index) in detailedItem.order_substatuses"
                              :key="index"
                              class="table-mini-info-details shadow-orange mb-2 mr-2"
                            >
                              <div class="d-flex justify-content-between align-items-center my-2">
                                <div>
                                  {{ substatus.substatus_local }}
                                </div>
                                <div>
                                  <b-icon
                                    icon="x"
                                    scale="1.7"
                                    variant="danger"
                                    class="float-right cursor-pointer ml-2"
                                    title="Отменить статус"
                                    @click="orderSubstatusDelete(substatus.id, index)"
                                  ></b-icon>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            Не отмечалось
                          </template>
                        </div>
                        <hr v-if="detailedItem.order_substatuses.length < 2">
                        <div class="align-items-center d-flex justify-content-between">
                          <template>
                            <div class="d-block">
                              <div v-if="issetLogisticsInOrder() && detailedItem.reference_order_type_id == 2">
                                <span
                                  v-if="!isSubstatus(261)"
                                  class="btn btn-outline-secondary"
                                  @click="orderSubstatusCreate(261)"
                                ><i class="fas fa-check mr-1"></i> ТЭО закрыто
                                </span>
                              </div>
                              <template v-if="detailedItem.reference_order_type_id == 1">
                                <div class="mb-1" v-if="issetSmthOfTOInOrder()">
                                  <span
                                    v-if="!isSubstatus(551)"
                                    class="btn btn-outline-secondary"
                                    @click="orderSubstatusCreate(551)"
                                  ><i class="fas fa-check mr-1"></i> Котировка по ТО готова
                                  </span>
                                </div>
                                <div class="mb-1" v-if="issetLogisticsInOrder()">
                                  <span
                                    v-if="!isSubstatus(552)"
                                    class="btn btn-outline-secondary"
                                    @click="orderSubstatusCreate(552)"
                                  ><i class="fas fa-check mr-1"></i> Котировка по ТЭО готова
                                  </span>
                                </div>
                                <template v-if="onlyForHeads()">
                                  <div class="mb-1" v-if="issetSmthOfTOInOrder()">
                                    <span
                                      v-if="!isSubstatus(553) && isSubstatus(551)"
                                      class="btn btn-outline-success"
                                      @click="orderSubstatusCreate(553)"
                                    ><i class="fas fa-check mr-1"></i> Котировка по ТО утверждена
                                    </span>
                                  </div>
                                  <div class="mb-1" v-if="issetLogisticsInOrder()">
                                    <span
                                      v-if="!isSubstatus(554) && isSubstatus(552)"
                                      class="btn btn-outline-success"
                                      @click="orderSubstatusCreate(554)"
                                    ><i class="fas fa-check mr-1"></i> Котировка по ТЭО утверждена
                                    </span>
                                  </div>
                                </template>
                              </template>
                            </div>
                          </template>
                        </div>
                      </td>
                    </tr>
                    <tr>
                        <td class="table-title-details">Тип заказа</td>
                        <td>
                            <span 
                                :class="getOrderTypeClass(detailedItem.reference_order_type_id)"
                                class="order-badge"
                            >
                                {{ getOrderTypeText(detailedItem.reference_order_type_id) }}
                            </span>
                            <template v-if="checkActionAllow('distribute-services')
                                            && detailedItem.reference_order_type_id == 2
                                            && checkIfDistributed(detailedItem)
                                            && !isAgent
                                            && detailedItem.reference_status_id != 361">
                                <button
                                    class="btn btn-outline-green ml-2 p-1 d-inline-flex align-items-center justify-content-center"
                                    type="button"
                                    :aria-label="'Распределить услуги по сотрудникам'"
                                    title="Распределить услуги по сотрудникам"
                                    @click="openServiceDistributionModal()"
                                >
                                    <i class="fas fa-project-diagram" aria-hidden="true"></i>
                                </button>
                            </template>
                        </td>
                    </tr>
                    <tr v-if="false"></tr>
                    <tr>
                        <td class="table-title-details" style="vertical-align: top;">Наименование компании</td>
                        <td>
                            <span
                                v-if="detailedItem.company"
                                class="sidebar-link"
                                @click="openCompanySidebar(detailedItem.company_id)"
                            >
                                {{ detailedItem.company.name }}
                            </span>
                            <span v-else>Не задана</span>
                            /
                            <span>
                                {{ detailedItem.company ? detailedItem.company.inn : "ИНН пока не задан" }}
                            </span>

                            <div v-if="detailedItem.company">
                                <b-badge 
                                    v-if="detailedItem.company.status"
                                    :variant="detailedItem.company.reference_company_status_id == 370 ? 'danger':'secondary'"
                                    class="always-small-badge"
                                    title="Статус выставлен менеджером"
                                >
                                    {{ detailedItem.company.status.name }}
                                </b-badge>
                                <template v-if="detailedItem.company.latest_dadata_check && detailedItem.company.latest_dadata_check.is_liquidated">
                                    <b-badge 
                                        variant="danger" 
                                        class="always-small-badge ml-2"
                                        title="Статус выставлен в ходе последней автоматической проверки из открытых источников"
                                    >
                                        Авто проверка: Ликвидирована
                                    </b-badge>
                                </template>
                                <template v-if="String(detailedItem.company.inn).length < 10">
                                    <b-badge 
                                        variant="danger" 
                                        class="always-small-badge"
                                        title="Статус выставлен в ходе последней автоматической проверки из открытых источников"
                                    >
                                        Ошибка ИНН
                                    </b-badge>
                                </template>                                  
                            </div>

                            <div 
                                class="bookmarked-comments-of-company" 
                                v-if="detailedItem.company && detailedItem.company.bookmarked_comments && detailedItem.company.bookmarked_comments.length > 0"
                            >
                                <div v-for="item in detailedItem.company.bookmarked_comments">
                                    <span v-html="item.comment"></span>
                                </div>
                            </div>
                        </td>
                    </tr>
                    <tr>
                        <td class="table-title-details">Клиент</td>
                        <td>
                            <div class="d-flex flex-column">
                                <div class="mb-2">{{ detailedItem.company_employee ? detailedItem.company_employee.lead_fio : (detailedItem.contacts && detailedItem.contacts.lead_fio) ? detailedItem.contacts.lead_fio : "ФИО не указан" }}</div>
                                <div class="mb-2">{{ detailedItem.company_employee ? detailedItem.company_employee.lead_email : (detailedItem.contacts && detailedItem.contacts.lead_email) ? detailedItem.contacts.lead_email : "E-mail не указан" }}</div>
                                <make-a-call
                                    v-if="detailedItem.company_employee"
                                    :size="1.5"
                                    :outbound_number="detailedItem.company_employee.lead_phone"
                                    target_type="order"
                                    :target_id="detailedItem.id"
                                    :company_id="detailedItem.company_id"
                                    @callWasMade="callWasMade"
                                />
                                <make-a-call
                                    v-else-if="detailedItem.contacts && detailedItem.contacts.lead_phone"
                                    :size="1.5"
                                    :outbound_number="detailedItem.contacts.lead_phone"
                                    target_type="order"
                                    :target_id="detailedItem.id"
                                    @callWasMade="callWasMade"
                                />
                                <span v-else> Телефон не указан </span>
                            </div>
                        </td>
                    </tr>
                    <tr v-if="!isAgent">
                        <td class="table-title-details">Sales менеджер заказа</td>
                        <td>{{ getSalesManagerName() }}</td>
                    </tr>
                    <tr v-if="!isAgent">
                        <td class="table-title-details">Sales менеджер компании</td>
                        <td>{{ getCompanySalesManagerName() }}</td>
                    </tr>
                    <tr v-if="!isAgent">
                        <td class="table-title-details">ТО менеджер компании</td>
                        <td>{{ getCompanyToManagerName() }}</td>
                    </tr>
                    <tr v-if="!isAgent">
                        <td class="table-title-details">ТЭО менеджер компании</td>
                        <td>{{ getCompanyTeoManagerName() }}</td>
                    </tr>
                    <tr>
                        <td class="table-title-details">Заказ создал</td>
                        <td>
                            <template v-if="!isEditCreator">
                                <span>{{ detailedItem.creator ? detailedItem.creator.name : "Не известно" }}</span>
                                <button
                                    v-if="canEditCreator()"
                                    type="button"
                                    class="btn btn-outline-green float-right"
                                    @click="isEditCreator=!isEditCreator"
                                >
                                    Изменить
                                </button>
                            </template>
                            <template v-if="isEditCreator">
                                <div class="row" style="align-items: center;">
                                    <div class="col-8">
                                        <tsoft-select-user
                                            id="creator_user_id"
                                            :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||president||bsz-manager||b2c-head-manager||b2c-manager||agent`"
                                            :needNullElement="false"
                                            :selected="detailedItem.creator_user_id"
                                            @set="setCreatorOfOrder"
                                        ></tsoft-select-user>
                                    </div>
                                    <div class="col-4">
                                        <button
                                            type="button"
                                            class="btn btn-outline-green float-right"
                                            @click="saveCreatorOfOrder"
                                        >
                                            Сохранить
                                        </button>
                                    </div>
                                </div>
                            </template>
                        </td>
                    </tr>
                    <tr>
                        <td class="table-title-details">Категории заказа</td>
                        <td>{{ detailedItem.selected_categories || "Не заданы" }}</td>
                    </tr>
                    <tr>
                        <td class="table-title-details">Источник поставки</td>
                        <td>{{ detailedItem.source ? detailedItem.source.name : "Не указан" }}</td>
                      </tr>
                      <tr>
                        <td class="table-title-details">Источник клиента</td>
                        <td>{{ (detailedItem.company && detailedItem.company.source) ? detailedItem.company.source.name : "Не указан" }}</td>
                      </tr>
                        <tr>
                        <td class="table-title-details">Дата получения заявки</td>
                        <td>{{ detailedItem.receive_datetime | formattedDateTime }}</td>
                    </tr>
                    <tr>
                        <td class="table-title-details">Дата отработки заявки (КП направлено/консультация оказана)</td>
                        <td>{{ detailedItem.processing_end_datetime | formattedDateTime }}</td>
                    </tr>
                </tbody>
                </table>

                <!-- New details-group layout -->
                <div class="form-row">
                  <div class="form-group col-md-6">
                    <div class="details-group">
                      <div class="value-of-field" title="Предполагаемая маржинальная прибыль в рублях">
                        <template v-if="detailedItem.predictable_mp">
                          {{ detailedItem.predictable_mp | toCurrency }} руб.
                        </template>
                        <template v-else>
                          Не указана
                        </template>
                      </div>
                      <div class="descr-of-field">Предполагаемая МП, руб.</div>
                    </div>

                    <div class="details-group" v-if="!isAgent">
                      <div class="value-of-field">{{ detailedItem.outsourcing_type_name }}</div>
                      <div class="descr-of-field">Аутсорсинг</div>
                    </div>

                    <div class="details-group" v-if="detailedItem.short_order">
                      <div class="value-of-field">{{ detailedItem.temp_name || '' }}</div>
                      <div class="descr-of-field">Условное наименование</div>
                    </div>

                    <div class="details-group">
                      <div class="value-of-field d-flex align-items-center">
                        <span 
                            :class="getOrderTypeClass(detailedItem.reference_order_type_id)"
                            class="order-badge"
                        >
                            {{ getOrderTypeText(detailedItem.reference_order_type_id) }}
                        </span>
                        <template v-if="checkActionAllow('distribute-services')
                                        && detailedItem.reference_order_type_id == 2
                                        && checkIfDistributed(detailedItem)
                                        && !isAgent
                                        && detailedItem.reference_status_id != 361">
                          <button
                            class="btn btn-outline-green ml-2 p-1 d-inline-flex align-items-center justify-content-center"
                            type="button"
                            :aria-label="'Распределить услуги по сотрудникам'"
                            title="Распределить услуги по сотрудникам"
                            @click="openServiceDistributionModal()"
                          >
                            <i class="fas fa-project-diagram" aria-hidden="true"></i>
                          </button>
                        </template>
                      </div>
                      <div class="descr-of-field">Тип заказа</div>
                    </div>

                    <div class="details-group">
                      <div class="value-of-field">
                        <template v-if="detailedItem.selected_services.length > 0">
                          <div class="service-chips">
                            <span
                              v-for="(item, index) in detailedItem.selected_services"
                              :key="item.id"
                              :class="['service-chip', { 'service-chip--readonly': isLeadObserver }]"
                              :title="isLeadObserver ? '' : 'Открыть детали услуги'"
                              @click="!isLeadObserver && openOrderSidebar('', '', {tab: item.id})"
                            >{{ item.name }}</span>
                          </div>
                        </template>
                        <template v-else>
                          Не заданы
                        </template>
                      </div>
                      <div class="descr-of-field">Виды услуг</div>
                    </div>

                    <div class="details-group">
                      <div class="value-of-field">
                        <span
                          v-if="detailedItem.company"
                          class="sidebar-link"
                          @click="openCompanySidebar(detailedItem.company_id)"
                        >
                          {{ detailedItem.company.name }}
                        </span>
                        <span v-else>Не задана</span>
                        /
                        <span>
                          {{ detailedItem.company ? detailedItem.company.inn : 'ИНН пока не задан' }}
                        </span>

                        <div v-if="detailedItem.company && !isAgent" class="mt-2">
                          <b-badge 
                            v-if="detailedItem.company.status"
                            :variant="detailedItem.company.reference_company_status_id == 370 ? 'danger':'secondary'"
                            class="always-small-badge"
                            title="Статус выставлен менеджером"
                          >
                            {{ detailedItem.company.status.name }}
                          </b-badge>
                          <template v-if="detailedItem.company.latest_dadata_check && detailedItem.company.latest_dadata_check.is_liquidated">
                            <b-badge 
                              variant="danger" 
                              class="always-small-badge ml-2"
                              title="Статус выставлен в ходе последней автоматической проверки из открытых источников"
                            >
                              Авто проверка: Ликвидирована
                            </b-badge>
                          </template>
                          <template v-if="String(detailedItem.company.inn).length < 10">
                            <b-badge 
                              variant="danger" 
                              class="always-small-badge"
                              title="Статус выставлен в ходе последней автоматической проверки из открытых источников"
                            >
                              Ошибка ИНН
                            </b-badge>
                          </template>
                        </div>

                        <div 
                          class="bookmarked-comments-of-company"
                          v-if="detailedItem.company && detailedItem.company.bookmarked_comments && detailedItem.company.bookmarked_comments.length > 0"
                        >
                          <div v-for="item in detailedItem.company.bookmarked_comments" :key="item.id">
                            <span v-html="item.comment"></span>
                          </div>
                        </div>
                      </div>
                      <div class="descr-of-field">Наименование компании</div>
                    </div>

                    <div class="details-group">
                      <div class="value-of-field">
                        <div class="d-flex flex-column">
                          <div class="mb-2">{{ detailedItem.company_employee ? detailedItem.company_employee.lead_fio : (detailedItem.contacts && detailedItem.contacts.lead_fio) ? detailedItem.contacts.lead_fio : 'ФИО не указан' }}</div>
                          <div class="mb-2">{{ detailedItem.company_employee ? detailedItem.company_employee.lead_email : (detailedItem.contacts && detailedItem.contacts.lead_email) ? detailedItem.contacts.lead_email : 'E-mail не указан' }}</div>
                          <make-a-call
                            v-if="detailedItem.company_employee"
                            :size="1.5"
                            :outbound_number="detailedItem.company_employee.lead_phone"
                            target_type="order"
                            :target_id="detailedItem.id"
                            :company_id="detailedItem.company_id"
                            @callWasMade="callWasMade"
                          />
                          <make-a-call
                            v-else-if="detailedItem.contacts && detailedItem.contacts.lead_phone"
                            :size="1.5"
                            :outbound_number="detailedItem.contacts.lead_phone"
                            target_type="order"
                            :target_id="detailedItem.id"
                            @callWasMade="callWasMade"
                          />
                          <span v-else> Телефон не указан </span>
                        </div>
                      </div>
                      <div class="descr-of-field">Клиент</div>
                    </div>

                    <div class="details-group" v-if="!isAgent">
                      <div class="value-of-field">{{ getSalesManagerName() }}</div>
                      <div class="descr-of-field">Sales менеджер заказа</div>
                    </div>

                    <div class="details-group" v-if="!isAgent">
                      <div class="value-of-field">{{ getCompanySalesManagerName() }}</div>
                      <div class="descr-of-field">Sales менеджер компании</div>
                    </div>

                    <div class="details-group" v-if="!isAgent">
                      <div class="value-of-field">{{ getCompanyToManagerName() }}</div>
                      <div class="descr-of-field">ТО менеджер компании</div>
                    </div>

                    <div class="details-group" v-if="!isAgent">
                      <div class="value-of-field">{{ getCompanyTeoManagerName() }}</div>
                      <div class="descr-of-field">ТЭО менеджер компании</div>
                    </div>
                  </div>

                  <div class="form-group col-md-6">
                    <div class="details-group" v-if="detailedItem.related_orders.length > 0">
                      <div class="value-of-field">
                        <div v-for="order in detailedItem.related_orders" :key="order.id">
                          <span
                            class="text-uppercase sidebar-link font-size-12"
                            @click="openOrderSidebar(order.id, '', '')"
                          >
                            <template v-if="order.text_mark">
                              {{ order.text_mark }} <span class="text-muted">(#{{ order.id }})</span>
                            </template>
                            <template v-else>
                              {{ order.id }}
                            </template>
                          </span>
                        </div>
                      </div>
                      <div class="descr-of-field">Другие расчёты</div>
                    </div>

                    <div class="details-group" v-if="detailedItem.bitrix_deal_id">
                      <div class="value-of-field">{{ detailedItem.bitrix_deal_id }}</div>
                      <div class="descr-of-field">ID заказа в Битрикс 24</div>
                    </div>

                    <div class="details-group" v-if="!isAgent">
                      <div class="value-of-field">{{ getStatusName() }}</div>
                      <div class="descr-of-field">Статус заказа</div>
                    </div>

                    <div class="details-group" v-if="detailedItem.comment">
                      <div class="value-of-field sm-value-of-field">
                        {{ (detailedItem.comment == 'null' || !detailedItem.comment) ? 'Не указан' : detailedItem.comment }}
                      </div>
                      <div class="descr-of-field">Комментарий к заказу</div>
                    </div>

                    <div class="details-group" v-if="detailedItem.reference_close_reason_id && detailedItem.reference_status_id == 362">
                      <div class="value-of-field text-danger">{{ getCloseReason() }}</div>
                      <div class="descr-of-field">Причина отказа</div>
                    </div>

                    <div class="details-group" v-if="detailedItem.reference_close_reason_id && detailedItem.reference_status_id != 362">
                      <div class="value-of-field text-danger">{{ getCloseReason() }}</div>
                      <div class="descr-of-field">Ранее был отказ клиента</div>
                    </div>

                    <div class="details-group" v-if="detailedItem.close_comment">
                      <div class="value-of-field sm-value-of-field">
                        {{ (detailedItem.close_comment == 'null' || !detailedItem.close_comment) ? 'Не указан' : detailedItem.close_comment }}
                      </div>
                      <div class="descr-of-field">Комментарий к отказу</div>
                    </div>

                    <div class="details-group" v-if="!isAgent">
                      <div class="value-of-field">
                        <div class="align-items-center d-flex justify-content-between flex-wrap">
                          <template v-if="detailedItem.order_substatuses.length > 0">
                            <div
                              v-for="(substatus, index) in detailedItem.order_substatuses"
                              :key="index"
                              class="table-mini-info-details shadow-orange mb-2 mr-2"
                            >
                              <div class="d-flex justify-content-between align-items-center my-2">
                                <div>
                                  {{ substatus.substatus_local }}
                                </div>
                                <div>
                                  <b-icon
                                    icon="x"
                                    scale="1.7"
                                    variant="danger"
                                    class="float-right cursor-pointer ml-2"
                                    title="Отменить статус"
                                    @click="orderSubstatusDelete(substatus.id, index)"
                                  ></b-icon>
                                </div>
                              </div>
                            </div>
                          </template>
                          <template v-else>
                            Не отмечалось
                          </template>
                        </div>
                        <hr v-if="detailedItem.order_substatuses.length < 2" class="small">
                        <div class="align-items-center d-flex justify-content-between">
                          <template>
                            <div class="d-block">
                              <div v-if="issetLogisticsInOrder() && detailedItem.reference_order_type_id == 2">
                                <span
                                  v-if="!isSubstatus(261)"
                                  class="btn btn-outline-secondary fs12px h25px lh12px"
                                  @click="orderSubstatusCreate(261)"
                                ><i class="fas fa-check mr-1"></i> ТЭО закрыто
                                </span>
                              </div>
                              <template v-if="detailedItem.reference_order_type_id == 1">
                                <div class="mb-1" v-if="issetSmthOfTOInOrder()">
                                  <span
                                    v-if="!isSubstatus(551)"
                                    class="btn btn-outline-secondary fs12px h25px lh12px"
                                    @click="orderSubstatusCreate(551)"
                                  ><i class="fas fa-check mr-1"></i> Котировка по ТО готова
                                  </span>
                                </div>
                                <div class="mb-1" v-if="issetLogisticsInOrder()">
                                  <span
                                    v-if="!isSubstatus(552)"
                                    class="btn btn-outline-secondary fs12px h25px lh12px"
                                    @click="orderSubstatusCreate(552)"
                                  ><i class="fas fa-check mr-1"></i> Котировка по ТЭО готова
                                  </span>
                                </div>
                                <template v-if="onlyForHeads()">
                                  <div class="mb-1" v-if="issetSmthOfTOInOrder()">
                                    <span
                                      v-if="!isSubstatus(553) && isSubstatus(551)"
                                      class="btn btn-outline-success fs12px h25px lh12px text-uppercase"
                                      @click="orderSubstatusCreate(553)"
                                    ><i class="fas fa-check mr-1"></i> Котировка по ТО утверждена
                                    </span>
                                  </div>
                                  <div class="mb-1" v-if="issetLogisticsInOrder()">
                                    <span
                                      v-if="!isSubstatus(554) && isSubstatus(552)"
                                      class="btn btn-outline-success fs12px h25px lh12px text-uppercase"
                                      @click="orderSubstatusCreate(554)"
                                    ><i class="fas fa-check mr-1"></i> Котировка по ТЭО утверждена
                                    </span>
                                  </div>
                                </template>
                              </template>
                            </div>
                          </template>
                        </div>
                      </div>
                      <div class="descr-of-field">Отметки</div>
                    </div>

                    <div class="details-group">
                      <div class="value-of-field">{{ detailedItem.selected_categories || 'Не заданы' }}</div>
                      <div class="descr-of-field">Категории заказа</div>
                    </div>

                    <div class="details-group">
                      <div class="value-of-field">{{ detailedItem.source ? detailedItem.source.name : 'Не указан' }}</div>
                      <div class="descr-of-field">Источник поставки</div>
                    </div>

                    <div class="details-group">
                      <div class="value-of-field">{{ (detailedItem.company && detailedItem.company.source) ? detailedItem.company.source.name : 'Не указан' }}</div>
                      <div class="descr-of-field">Источник клиента</div>
                    </div>

                    <div class="details-group">
                      <div class="value-of-field">{{ detailedItem.receive_datetime | formattedDateTime }}</div>
                      <div class="descr-of-field">Дата получения заявки</div>
                    </div>

                    <div class="details-group">
                      <div class="value-of-field">{{ detailedItem.processing_end_datetime | formattedDateTime }}</div>
                      <div class="descr-of-field">Дата отработки заявки (КП направлено/консультация оказана)</div>
                    </div>

                    <div class="details-group">
                      <div class="value-of-field">
                        <template v-if="!isEditCreator">
                          <span>{{ detailedItem.creator ? detailedItem.creator.name : 'Не известно' }}</span>
                          <button
                            v-if="canEditCreator()"
                            type="button"
                            class="btn btn-outline-green float-right"
                            @click="isEditCreator=!isEditCreator"
                          >
                            Изменить
                          </button>
                        </template>
                        <template v-if="isEditCreator">
                          <div class="row" style="align-items: center;">
                            <div class="col-8">
                              <tsoft-select-user
                                id="creator_user_id"
                                :roles="`sales-manager||sales-head-manager||logistics-manager||logistics-head-manager||logistics-multim-manager||logistics-multim-head-manager||TO-manager||TO-head-manager||president||bsz-manager||b2c-head-manager||b2c-manager||agent`"
                                :needNullElement="false"
                                :selected="detailedItem.creator_user_id"
                                @set="setCreatorOfOrder"
                              ></tsoft-select-user>
                            </div>
                            <div class="col-4">
                              <button
                                type="button"
                                class="btn btn-outline-green float-right"
                                @click="saveCreatorOfOrder"
                              >
                                Сохранить
                              </button>
                            </div>
                          </div>
                        </template>
                      </div>
                      <div class="descr-of-field">Заказ создал</div>
                    </div>
                  </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import { mapGetters } from 'vuex';
    import { checkActionAllow } from '@/mixins';
    import { openCompanySidebar } from '@/mixins/openCompanySidebar';
    import { openOrderSidebar } from '@/mixins/openOrderSidebar';
    import { API_COMMENTS, API_POST_ORDERS_SUBSTATUS_CREATE, API_DELETE_ORDERS_SUBSTATUS_DELETE } from '@/constants';
    import MakeACall from '../phone/MakeACall.vue';

    export default {
        components: {
            MakeACall
        },
        props: {
            detailedItemIndex: { type: Number, required: false, default: 0 },
            detailedItem: { type: Object, required: true },
        },
        mixins: [
            checkActionAllow,
            openCompanySidebar,
            openOrderSidebar
        ],
        data() {
            return {
                apiComments: API_COMMENTS,
                isEditCreator: false,
                newCreatorOfOrder: ''
            }
        },
        computed: {
            ...mapGetters("auth", ["currentUser"]),
            isAdmin() {
                return this.currentUser.role && this.currentUser.role.includes('administrator');
            },
            isAgent() {
                return this.currentUser.role && this.currentUser.role.includes('agent');
            },
            isLeadObserver() {
                return this.currentUser.role && this.currentUser.role.includes('lead-observer');
            },
        },
        methods: {
            closeOrder(index) {
                this.$emit('closeOrder', index)
            },
            changeOrderStatus(id, newStatus = 361) {
                this.$emit('changeOrderStatus', id, newStatus)
            },
            fastChangeStatusOfOrder(newStatus) {
                this.detailedItem.loading = true
                this.changeOrderStatus(this.detailedItem.id, newStatus)
            },
            getSalesManagerName() {
                let name = "Не известен"
                if (this.detailedItem.company && this.detailedItem.company.sales_manager) {
                    name = this.detailedItem.company.sales_manager.name
                }
                // if we have sales manager on one order
                if (this.detailedItem.optional_sales_manager && this.detailedItem.optional_sales_manager.name) {
                    name = this.detailedItem.optional_sales_manager.name
                }
                return name
            },
            getCompanySalesManagerName() {
                let name = "Не известен"
                if (this.detailedItem.company && this.detailedItem.company.sales_manager) {
                    name = this.detailedItem.company.sales_manager.name
                }
                return name
            },
            getCompanyToManagerName() {
                let name = "Не известен"
                if (this.detailedItem.company && this.detailedItem.company.to_manager) {
                    name = this.detailedItem.company.to_manager.name
                }
                return name
            },
            getCompanyTeoManagerName() {
                let name = "Не известен"
                if (this.detailedItem.company && this.detailedItem.company.teo_manager) {
                    name = this.detailedItem.company.teo_manager.name
                }
                return name
            },
            getStatusName() {
                let name = "Не известен"
                if (this.detailedItem.status && this.detailedItem.status.name) {
                    name = this.detailedItem.status.name
                }
                return name
            },
            getCloseReason() {
                let name = ''
                if (this.detailedItem.close_reason && this.detailedItem.close_reason.name) {
                    name = this.detailedItem.close_reason.name.replace(/\s*\(.*\)/,'')
                }

                return name
            },
            setCreatorOfOrder(creator_user_id) {
                this.newCreatorOfOrder = creator_user_id
            },
            saveCreatorOfOrder() {
                let data = {
                    creator_user_id: this.newCreatorOfOrder
                }

                if (this.detailedItem.optional_sales_manager_user_id &&
                    this.detailedItem.optional_sales_manager_user_id == this.detailedItem.creator_user_id) {
                    data.optional_sales_manager_user_id = this.newCreatorOfOrder
                }

                this.$emit('changeCreatorUserId', this.detailedItem.id, data, this.detailedItemIndex)

                this.isEditCreator = false
                this.newCreatorOfOrder = ''
            },
            canEditCreator() {
                if (this.currentUser.role.includes("administrator") ||
                    this.currentUser.role.includes("sales-head-manager") ||
                    this.currentUser.role.includes("logistics-head-manager") ||
                    this.currentUser.role.includes("logistics-multim-head-manager") ||
                    this.currentUser.role.includes("TO-head-manager")) {
                    return true
                }
                return false
            },
            checkIfDistributed(item) {
                const uniqueServiceIds = [...new Set(item.service_users.map(user => user.service_id))];

                if (item.service_users && item.selected_services) {
                    if (uniqueServiceIds.length == item.selected_services.length) {
                        return false
                    }
                }
                return true
            },
            makeOrderSupplyByID(id) {
                this.$emit('makeOrderSupplyByID', id)
            },
            openServiceDistributionModal() {
                this.$emit('openServiceDistributionModal')
            },
            callWasMade() {
                this.$emit('updateOrderHistory')
            },
            issetSmthOfTOInOrder() {
                let issetSmthOfTO = false

                if (this.detailedItem.selected_services) {
                    this.detailedItem.selected_services.forEach((service) => {
                        // Если есть что-то кроме логистики
                        if (service.id !== 23) {
                            issetSmthOfTO = true
                        }
                    })
                }

                return issetSmthOfTO
            },
            issetLogisticsInOrder() {
                let issetLogistic = false

                if (this.detailedItem.selected_services) {
                    this.detailedItem.selected_services.forEach((service) => {
                        // Если есть ТЭО (Логистика)
                        if (service.id === 23) {
                            issetLogistic = true
                        }
                    })
                }

                return issetLogistic
            },
            isSubstatus(reference_substatus_id) {
                let result = false
                this.detailedItem.order_substatuses.forEach((substatus) => {
                    if (reference_substatus_id == substatus.reference_substatus_id) {
                        result = true
                    }
                })

                return result
            },
            orderSubstatusCreate(reference_substatus_id) {
                let order_id = this.detailedItem.id
                this.dataOverlay = true
                api.call("post", `${API_POST_ORDERS_SUBSTATUS_CREATE}/${order_id}/${reference_substatus_id}`)
                    .then(({data}) => {
                        this.detailedItem.order_substatuses.push(data)
                        this.$emit('fullOrderUpdate')
                        this.dataOverlay = false
                    })
            },
            orderSubstatusDelete(reference_substatus_id, index) {
                this.dataOverlay = true
                api.call("delete", `${API_DELETE_ORDERS_SUBSTATUS_DELETE}/${reference_substatus_id}`)
                    .then(({data}) => {
                        this.detailedItem.order_substatuses.splice(index, 1)
                        this.$emit('updateOrderHistory')
                        this.dataOverlay = false
                    })
            },
            whyICanBeDisabled() {
                let result = false

                // if (this.detailedItem.reference_order_type_id == 1 &&
                //     this.detailedItem.reference_status_id === 541) {
                //     result = true
                // }

                // if (this.detailedItem.reference_order_type_id == 1 &&
                //     this.detailedItem.reference_status_id === 541) {
                //     if (this.issetSmthOfTOInOrder() && !this.isSubstatus(553)) {
                //         result = true
                //     }
                //     if (this.issetLogisticsInOrder() && !this.isSubstatus(554)) {
                //         result = true
                //     }
                // }

                return result
            },
            onlyForHeads() {
                if (this.currentUser.role && (this.currentUser.role.includes("administrator") ||
                    this.currentUser.role.includes("TO-head-manager") ||
                    this.currentUser.role.includes("logistics-head-manager") ||
                    this.currentUser.role.includes("logistics-multim-head-manager") ||
                    this.currentUser.role.includes("president"))) {
                    return true
                }
                return false
            },
            getOrderTypeClass(orderTypeId) {
                // Определяем CSS класс в зависимости от типа заказа
                switch (orderTypeId) {
                    case 1:
                        return 'order-type-request'; // Заявка - зеленый
                    case 2:
                        return 'order-type-supply'; // Поставка - оранжевый
                    default:
                        return 'order-type-unknown'; // Неизвестный тип - серый
                }
            },
            getOrderTypeText(orderTypeId) {
                // Определяем текст в зависимости от типа заказа
                switch (orderTypeId) {
                    case 1:
                        return 'Заявка';
                    case 2:
                        return 'Поставка';
                    default:
                        return 'Неизвестно';
                }
            }
        }
    }
</script>
<style scoped>
.order-header {
    background: #f7faf9;
    border: 1px solid rgba(13, 99, 72, 0.15);
    border-left: 4px solid #0d6348;
    border-radius: 0.2rem;
}
.order-badge {
    background: rgba(227, 121, 38, 0.1);
    color: #e37926;
    border: 1px solid rgba(227, 121, 38, 0.3);
    border-radius: 0.2rem;
    padding: 4px 10px;
    font-weight: 600;
    line-height: 1;
}
.status-chip {
    display: inline-flex;
    align-items: center;
    background: #6c6c6c;
    color: #ffffff;
    border-radius: 0.2rem;
    padding: 6px 12px;
    font-size: 12px;
    text-transform: uppercase;
}
.details-table td {
    padding-top: 0.4rem;
    padding-bottom: 0.4rem;
}
.details-table .table-title-details {
    width: auto;
    color: #6c757d;
    font-weight: 600;
    font-size: 12px;
    text-transform: uppercase;
    letter-spacing: 0.02em;
}
.details-table tbody {
    display: grid;
    grid-template-columns: minmax(200px, 260px) 1fr minmax(200px, 260px) 1fr;
    grid-column-gap: 24px;
}
.details-table tr {
    display: contents;
}
@media (max-width: 1199.98px) {
    .details-table tbody {
        grid-template-columns: minmax(200px, 260px) 1fr;
    }
}
.service-chips {
    display: flex;
    flex-wrap: wrap;
}
.service-chip {
    background: rgba(13, 99, 72, 0.08);
    color: #0d6348;
    border: 1px solid rgba(13, 99, 72, 0.25);
    border-radius: 0.2rem;
    padding: 4px 10px;
    margin: 0 6px 6px 0;
    font-weight: 600;
    cursor: pointer;
}
.service-chip--readonly {
    cursor: default;
}
.table-mini-info-details {
    background: rgba(227, 121, 38, 0.07);
    border: 1px solid rgba(227, 121, 38, 0.25);
    border-left: 4px solid #e37926;
    padding: 4px 10px;
    border-radius: 0.2rem;
}
.bookmarked-comments-of-company {
    margin-top: 15px;
}
.bookmarked-comments-of-company div {
    padding: 15px 15px 1px 15px;
    background: rgba(13, 99, 72, 0.06);
    margin-bottom: 10px;
    border-radius: 10px;
}

/* Стили для типов заказа */
.order-type-badge {
    display: inline-block;
    padding: 4px 12px;
    border-radius: 12px;
    font-weight: 600;
    font-size: 0.875rem;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.order-type-request {
    background-color: rgba(13, 99, 72, 0.1);
    color: #0d6348;
    border: 1px solid rgba(13, 99, 72, 0.3);
}

.order-type-supply {
    background-color: rgba(227, 121, 38, 0.1);
    color: #e37926;
    border: 1px solid rgba(227, 121, 38, 0.3);
}

.order-type-unknown {
    background-color: rgba(108, 117, 125, 0.1);
    color: #6c757d;
    border: 1px solid rgba(108, 117, 125, 0.3);
}
</style>